export default function GamesAtmosphere() {
  const games = [
    'Pac-Man',
    'Galaga',
    'Street Fighter II',
    'NBA Jam',
    'Mortal Kombat',
    'Donkey Kong',
    'Space Invaders',
    'Pinball Machines',
    'Skee-Ball',
    'Air Hockey',
    'Ms. Pac-Man',
    'Centipede'
  ];

  return (
    <section id="games" className="relative py-24 px-4 sm:px-6 lg:px-8">
      <div className="absolute inset-0 bg-[#0d1f3c]">
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'repeating-linear-gradient(90deg, transparent, transparent 2px, #00ffff 2px, #00ffff 4px)' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Text Content */}
          <div>
            <h2 className="text-4xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-orange-400 mb-6">
              Games &amp; Atmosphere
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-pink-500 to-orange-500 mb-8"></div>

            <p className="text-gray-300 text-lg leading-relaxed mb-6">
              Step into a neon-lit wonderland where nostalgia meets modern fun. Whether you're here for a date night, catching up with friends, or settling old scores in Street Fighter, our arcade bar delivers the perfect blend of retro gaming and craft beverages.
            </p>

            <p className="text-gray-300 text-lg leading-relaxed mb-8">
              Challenge your crew to classic tournaments, discover hidden gems from the golden age of gaming, or just kick back with a cold one while the sounds of 8-bit glory fill the air.
            </p>

            <div className="bg-gradient-to-br from-[#0a1628] to-[#0d1f3c] rounded-xl p-8 border border-cyan-500/30">
              <h3 className="text-2xl font-bold text-cyan-400 mb-6 flex items-center">
                <i className="ri-trophy-line mr-3"></i>
                Game Highlights
              </h3>
              <div className="grid grid-cols-2 gap-4">
                {games.map((game, index) => (
                  <div key={index} className="flex items-center space-x-3 group cursor-pointer">
                    <div className="w-2 h-2 bg-pink-500 rounded-full group-hover:bg-orange-400 transition-colors duration-300"></div>
                    <span className="text-gray-300 text-sm group-hover:text-cyan-400 transition-colors duration-300">
                      {game}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Visual Element */}
          <div className="relative">
            <div className="relative rounded-xl overflow-hidden border-4 border-cyan-500/30 shadow-[0_0_50px_rgba(34,211,238,0.3)]">
              <img
                src="https://public.readdy.ai/ai/img_res/55a1bf0598a66cdbeb24a6ea52f4ac3e.jpg"
                alt="Arcade Atmosphere"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628] via-transparent to-transparent"></div>
            </div>

            {/* Floating pixel accents */}
            <div className="absolute -top-4 -right-4 w-24 h-24 border-4 border-pink-500 opacity-50 animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 border-4 border-cyan-500 opacity-50 animate-pulse" style={{ animationDelay: '1s' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
}
